import PageHeader from "@/components/PageHeader";
import Seo from "@/components/Seo";

const PILLARS = [
  {
    title: "Live Works",
    body: "Night closures, traffic management, surfacing, structures and gantry installations, captured under operational conditions.",
  },
  {
    title: "People & Plant",
    body: "Operatives, supervisors and machinery at work, photographed with respect for site, safety and time.",
  },
  {
    title: "Drone & Film",
    body: "Aerial route surveys, project films, social cut-downs and scheme completion edits for major UK clients.",
  },
];

export default function AboutPage() {
  return (
    <div className="px-5 sm:px-8 lg:px-10 pt-10 lg:pt-12 pb-20">
      <Seo
        title="About"
        description="HighwaysLens is a specialist visual portfolio for highways, construction, infrastructure, and transport projects."
        path="/about"
      />
      <PageHeader
        eyebrow="Studio"
        title="About HighwaysLens"
        testid="about-header"
      />

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7 relative overflow-hidden aspect-[5/4] bg-[#0a0a0a]">
          <img
            src="https://images.unsplash.com/photo-1564668836804-05a2de350bb6?w=1600&q=85"
            alt="Night works coverage"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
        </div>
        <div className="lg:col-span-5 flex flex-col justify-center">
          <p className="text-[15px] text-[#c9d1d9] leading-relaxed">
            HighwaysLens is a specialist visual portfolio for highways,
            construction, infrastructure, and transport projects. It brings
            together photography and video content captured across live works,
            depots, structures, road schemes, events, and project environments.
          </p>
          <p className="text-[14px] text-[#A3A3A3] leading-relaxed mt-5">
            Every commission is shaped around the rhythm of the site, safety
            briefings, possession windows, traffic management changes, so
            that the final imagery is honest, considered, and on-brand.
          </p>
        </div>
      </div>

      <div className="mt-20">
        <h2 className="text-[10px] tracking-[0.32em] uppercase text-[#4A6D8C] mb-6">
          Services
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#1a1a1a] border border-[#1a1a1a]">
        {PILLARS.map((p) => (
          <div
            key={p.title}
            className="bg-[#0d0d0d] p-8"
            data-testid={`about-pillar-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="text-[10px] tracking-[0.32em] uppercase text-[#4A6D8C] mb-4">
              Discipline
            </div>
            <h3 className="font-display text-2xl tracking-tight text-white">
              {p.title}
            </h3>
            <p className="text-[14px] text-[#A3A3A3] mt-3 leading-relaxed">
              {p.body}
            </p>
          </div>
        ))}
        </div>
      </div>
    </div>
  );
}
